export enum RequestorTypeEnum {
  Finder = 1,
  Creator = 2,
}
